import $ from 'jquery';
import { doFetch } from '../../../remote/request.js';
import { debounce } from '../../../util/system.js';

/**
 * @param {jQuery | HTMLElement} _triggerInput
 */
export default (_triggerInput) => {

	/** @type {JQuery} */ // @ts-ignore
	const $triggerInput = _triggerInput.jquery ? _triggerInput : $(_triggerInput);
	const triggerInput = $triggerInput[0];
	// @ts-ignore
	const $form = $(triggerInput.form);
	const formRowSelector = mpro.config.ui.form_row_selector;
	let $shopSelectorWidget = $form.find('input[data-shop-selector], select[data-shop-selector]');
	const $ShopSelectorRow = $shopSelectorWidget.closest(formRowSelector);
	const widgetConfig = $triggerInput.data('check-shop-domains') || {};
	const { url } = widgetConfig;
	const name = $triggerInput.attr('name');

	let lastCheckedIdent = String($triggerInput.val()).trim();

	const checkIdentHandler = async () => {
		const val = String($triggerInput.val()).trim();

		if ((lastCheckedIdent !== val) && url && name) {
			lastCheckedIdent = val;

			try {
				const response = await doFetch(url, {
					method: 'POST',
					data: {
						[name]: val,
					},
				});

				if (response) {
					// Got a new shop selector
					if (response.widget) {
						replaceShopSelector(response.widget);
					}

					if (response.show === true) {
						showShopSelector();
					}
					else {
						hideShopSelector();
					}
				}
				else {
					hideShopSelector();
				}
			}
			catch (error) {
				console.warn('Error checking ident', error);
			}
		}
	};

	/**
	 * @param {string} newWidgetHtml
	 */
	const replaceShopSelector = (newWidgetHtml) => {
		if ($ShopSelectorRow.length === 0) {
			console.warn('replaceShopSelector: No shop selector widget found');
			return;
		}

		// Check if the widget is already there
		if ($ShopSelectorRow.html().trim() === newWidgetHtml.trim()) {
			return;
		}

		$ShopSelectorRow.empty().append(newWidgetHtml);
		$shopSelectorWidget = $form.find('input[data-shop-selector], select[data-shop-selector]');
	};

	const showShopSelector = () => {
		if ($ShopSelectorRow.length === 0) {
			console.warn('showShopSelector: No shop selector widget found');
			return;
		}

		$shopSelectorWidget.prop('disabled', false);
		$ShopSelectorRow.finish().slideDown('fast');
	};

	const hideShopSelector = () => {
		if ($ShopSelectorRow.length === 0) {
			console.warn('hideShopSelector: No shop selector widget found');
			return;
		}

		$shopSelectorWidget.prop('disabled', true);
		$ShopSelectorRow.finish().slideUp('fast', () => {
			$ShopSelectorRow.hide();
		});
	};

	const checkIdentDebounced = debounce(checkIdentHandler, 500);
	$triggerInput.on('focusout.shop-selector', checkIdentHandler);
	// @ts-ignore
	$triggerInput.on('keyup.shop-selector', checkIdentDebounced);
};